import { ClientInput } from "../inputs/ClientInput";
import { ClientTextArea } from "../inputs/ClientTextArea";
import { withDependentReferenceData } from "../../lib/customHooks/useReferenceData";
const ShortTextPreview = inputProps => <ClientInput {...inputProps} />;
const LongTextPreview = inputProps => <ClientTextArea {...inputProps} />;
const systemDefaults = {
  1: 'Username',
  2: 'Company Name',
  3: 'First Name',
  4: 'Last Name',
  5: 'Full Name (First and Last)',
  20: 'Customer Code',
  21: 'Site Code',
  22: 'Project Code'
};
const systemDefault = style => systemDefaults[style];
export const TextPreview = withDependentReferenceData(({
  original_type_id,
  update,
  required,
  read_only,
  default: defaultValue,
  value = defaultValue,
  style,
  label,
  id,
  errors,
  onBlur
}) => {
  const isShortText = original_type_id == 0;
  const TextField = isShortText ? ShortTextPreview : LongTextPreview;
  const systemDefaultValue = isShortText && systemDefault(style);
  const textFieldProps = {
    placeholder: '',
    value: systemDefaultValue || value,
    update,
    readOnly: read_only,
    disabled: read_only,
    label: `${required ? `${label}*` : label}`,
    error: errors,
    errorText: errors,
    required,
    id,
    onBlur,
    additionalClass: systemDefaultValue && `tool-tip-event completed`
  };
  return <TextField {...textFieldProps} />;
});